import React from "react";

const SuccessIcon = (styles: any) => (
  <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#00A645"
      d="M512 0a512 512 0 1 0 0.056889 1024.056889A512 512 0 0 0 512 0z m221.127111 344.746667l-240.64 333.767111a36.352 36.352 0 0 1-59.164444 0L290.929778 481.052444a9.159111 9.159111 0 0 1 7.395555-14.563555h53.589334c11.662222 0 22.755556 5.632 29.582222 15.246222l81.408 112.867556 179.655111-249.116445a36.522667 36.522667 0 0 1 29.582222-15.189333h53.646222c7.395556 0 11.776 8.419556 7.395556 14.506667z"
    />
  </svg>
);

const RetryIcon = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="27581"
    width="12"
    height="12"
  >
    <path
      fill="#7f7f7f"
      d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m182.044444 466.488889H329.955556a45.511111 45.511111 0 1 0 0 91.022222h364.088888a45.511111 45.511111 0 1 0 0-91.022222z"
      p-id="27582"
    />
  </svg>
);

const ErrorIcon = () => (
  <svg
    className="icon"
    width="12px"
    height="12.00px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#ED6A0C"
      d="M512 0a512 512 0 1 0 0.056889 1024.056889A512 512 0 0 0 512 0z m-36.579556 265.102222c0-5.006222 4.096-9.102222 9.102223-9.102222h54.897777c5.063111 0 9.102222 4.096 9.102223 9.102222v310.897778c0 5.006222-4.039111 9.102222-9.102223 9.102222h-54.840888a9.159111 9.159111 0 0 1-9.102223-9.102222V265.159111zM512 768a54.897778 54.897778 0 1 1 0-109.795556 54.897778 54.897778 0 0 1 0 109.795556z"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    className="icon"
    width="12px"
    height="12.00px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fontSize={24}
  >
    <path
      fill="#306FDC"
      d="M512 139.648c132.266667 0 251.349333 86.912 301.568 220.074667 110.08 28.245333 187.733333 135.509333 187.136 258.645333 0 146.688-109.568 265.984-244.352 265.984h-99.029333c-18.005333 0-32.597333-15.872-32.597334-35.413333 0-19.626667 14.592-35.498667 32.597334-35.498667h99.029333c98.816 0 179.2-87.509333 179.2-195.072 0.426667-96.128-63.872-178.090667-151.168-192.682667l-19.370667-3.328-6.4-20.181333c-36.138667-114.688-135.253333-191.658667-246.613333-191.616-111.36 0-210.517333 76.970667-246.613333 191.573333l-6.4 20.224-19.370667 3.328c-87.296 14.592-151.594667 96.554667-151.168 192.682667 0.085333 107.690667 80.256 194.986667 179.2 195.072h93.141333c18.005333 0 32.597333 15.872 32.597334 35.456 0 19.626667-14.592 35.456-32.597334 35.456H267.648c-134.784 0-244.352-119.296-244.352-265.984-0.597333-123.136 77.056-230.4 187.178667-258.645333C260.650667 226.56 379.733333 139.648 512 139.648z m0.128 178.474667c18.858667 0 34.133333 15.872 34.133333 35.413333V657.066667l112.853334-95.957334a33.152 33.152 0 0 1 34.048-6.4 36.181333 36.181333 0 0 1 9.258666 61.184v0.042667l-168.618666 143.445333a33.152 33.152 0 0 1-43.264 0L320.853333 615.04a36.181333 36.181333 0 0 1 9.557334-60.586667 33.109333 33.109333 0 0 1 33.706666 5.76l113.834667 96.853334V353.578667c0-19.626667 15.274667-35.456 34.133333-35.456z"
    />
  </svg>
);

const FailAllIcon = (styles: any) => (
  <svg
    className="icon"
    width="12px"
    height="12.00px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fontSize={24}
  >
    <path
      fill="#ED6A0C"
      d="M512 139.648c132.266667 0 251.349333 86.912 301.568 220.074667 110.08 28.245333 187.733333 135.509333 187.136 258.645333 0 146.688-109.568 265.984-244.352 265.984h-99.029333c-18.005333 0-32.597333-15.872-32.597334-35.413333 0-19.626667 14.592-35.498667 32.597334-35.498667h99.029333c98.816 0 179.2-87.509333 179.2-195.072 0.426667-96.128-63.872-178.090667-151.168-192.682667l-19.370667-3.328-6.4-20.181333c-36.138667-114.688-135.253333-191.658667-246.613333-191.616-111.36 0-210.517333 76.970667-246.613333 191.573333l-6.4 20.224-19.370667 3.328c-87.296 14.592-151.594667 96.554667-151.168 192.682667 0.085333 107.690667 80.256 194.986667 179.2 195.072h93.141333c18.005333 0 32.597333 15.872 32.597334 35.456 0 19.626667-14.592 35.456-32.597334 35.456H267.648c-134.784 0-244.352-119.296-244.352-265.984-0.597333-123.136 77.056-230.4 187.178667-258.645333C260.650667 226.56 379.733333 139.648 512 139.648zM507.733333 682.666667a59.733333 59.733333 0 1 1 0 119.466666 59.733333 59.733333 0 0 1 0-119.466666z m0-384a38.4 38.4 0 0 1 38.4 38.4v264.533333a38.4 38.4 0 1 1-76.8 0V337.066667a38.4 38.4 0 0 1 38.4-38.4z"
    />
  </svg>
);

const SuccessAllIcon = () => (
  <svg
    className="icon"
    width="12px"
    height="12.00px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fontSize={24}
  >
    <path
      fill="#00A645"
      d="M512 139.648c132.266667 0 251.349333 86.912 301.568 220.074667 110.08 28.245333 187.733333 135.509333 187.136 258.645333 0 146.688-109.568 265.984-244.352 265.984h-99.029333c-18.005333 0-32.597333-15.872-32.597334-35.413333 0-19.626667 14.592-35.498667 32.597334-35.498667h99.029333c98.816 0 179.2-87.509333 179.2-195.072 0.426667-96.128-63.872-178.090667-151.168-192.682667l-19.370667-3.328-6.4-20.181333c-36.138667-114.688-135.253333-191.658667-246.613333-191.616-111.36 0-210.517333 76.970667-246.613333 191.573333l-6.4 20.224-19.370667 3.328c-87.296 14.592-151.594667 96.554667-151.168 192.682667 0.085333 107.690667 80.256 194.986667 179.2 195.072h93.141333c18.005333 0 32.597333 15.872 32.597334 35.456 0 19.626667-14.592 35.456-32.597334 35.456H267.648c-134.784 0-244.352-119.296-244.352-265.984-0.597333-123.136 77.056-230.4 187.178667-258.645333C260.650667 226.56 379.733333 139.648 512 139.648z m223.488 334.208a34.133333 34.133333 0 0 1 2.56 44.501333l-3.370667 3.754667-258.688 250.197333a34.133333 34.133333 0 0 1-44.202666 2.773334l-3.797334-3.285334-154.325333-156.032a34.133333 34.133333 0 0 1 44.714667-51.328l3.84 3.328 130.56 132.010667 234.453333-226.730667a34.133333 34.133333 0 0 1 48.256 0.810667z"
    />
  </svg>
);

const RetrAllIcon = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="27551"
    width="12"
    height="12"
    fontSize={24}
  >
    <path
      fill="#306FDC"
      d="M512 139.648c132.266667 0 251.349333 86.912 301.568 220.074667 110.08 28.245333 187.733333 135.509333 187.136 258.645333 0 146.688-109.568 265.984-244.352 265.984h-99.029333c-18.005333 0-32.597333-15.872-32.597334-35.413333 0-19.626667 14.592-35.498667 32.597334-35.498667h99.029333c98.816 0 179.2-87.509333 179.2-195.072 0.426667-96.128-63.872-178.090667-151.168-192.682667l-19.370667-3.328-6.4-20.181333c-36.138667-114.688-135.253333-191.658667-246.613333-191.616-111.36 0-210.517333 76.970667-246.613333 191.573333l-6.4 20.224-19.370667 3.328c-87.296 14.592-151.594667 96.554667-151.168 192.682667 0.085333 107.690667 80.256 194.986667 179.2 195.072h93.141333c18.005333 0 32.597333 15.872 32.597334 35.456 0 19.626667-14.592 35.456-32.597334 35.456H267.648c-134.784 0-244.352-119.296-244.352-265.984-0.597333-123.136 77.056-230.4 187.178667-258.645333C260.650667 226.56 379.733333 139.648 512 139.648zM729.6 554.666667a38.4 38.4 0 1 1 0 76.8H294.4a38.4 38.4 0 1 1 0-76.8h435.2z"
      p-id="27552"
    />
  </svg>
);

const CancelIcon = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="27971"
    width="12"
    height="12"
  >
    <path
      d="M945.792 942.912a43.264 43.264 0 0 0 0-61.184L578.688 514.496l367.104-367.232a43.264 43.264 0 1 0-61.184-61.184L517.376 453.184 150.144 86.08a43.264 43.264 0 0 0-61.184 61.184L456.064 514.56 88.96 881.728a43.264 43.264 0 1 0 61.184 61.184l367.232-367.104 367.232 367.104a43.264 43.264 0 0 0 61.184 0z"
      p-id="27972"
    />
  </svg>
);

const UpIcon = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="58261"
    width="12"
    height="12"
  >
    <path
      d="M85.696 785.152L512 346.56l426.304 438.592c19.648 19.84 51.392 19.84 71.04 0a51.2 51.2 0 0 0 0-71.808L547.456 238.848a49.92 49.92 0 0 0-71.04 0L14.72 713.344a51.2 51.2 0 0 0 0 71.808c19.584 19.84 51.328 19.84 70.976 0z"
      p-id="58262"
    />
  </svg>
);

export {
  SuccessIcon,
  DownloadIcon,
  RetryIcon,
  ErrorIcon,
  FailAllIcon,
  SuccessAllIcon,
  RetrAllIcon,
  CancelIcon,
  UpIcon
};
